import { BreadcrumbsData } from '@systemeio/ui'
import { TLocoType } from 'shared/hooks/use-loco-translation'
import { getContactsPageNextjsUrl } from '../../utils/get-contacts-page-nextjs-url'

export const getBreadCrumbsData = (t: TLocoType) => {
  const breadcrumbsData: BreadcrumbsData[] = [
    {
      caption: t('dashboard.contacts.title_plural'),
      href: getContactsPageNextjsUrl(),
      isStatic: true,
    },
    {
      caption: t('dashboard.contacts.recently_deleted'),
      isStatic: true,
    },
  ]
  return breadcrumbsData
}
